import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box, IconButton, Link } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import Header from './Header';
import Footer from './Footer';
import RadioPlayer from './RadioPlayer';

const Layout: React.FC = () => {
  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Header />
      <Box component="main" sx={{ flex: 1, pt: 2 }}>
        <Outlet />
      </Box>
      <RadioPlayer />
      <Footer />

      {/* Boton flotante de WhatsApp */}
      <IconButton
        component={Link}
        href="https://wa.me/34621120000?text=Hola%20EfectoFM!"
        target="_blank"
        sx={{
          position: 'fixed',
          top: 100,
          left: 24,
          bgcolor: '#25D366',
          color: 'white',
          width: 56,
          height: 56,
          zIndex: 1100,
          boxShadow: '0 4px 12px rgba(37, 211, 102, 0.4)',
          '&:hover': {
            bgcolor: '#128C7E',
            transform: 'scale(1.1)',
          },
          transition: 'all 0.3s ease',
        }}
      >
        <WhatsAppIcon sx={{ fontSize: 32 }} />
      </IconButton>
    </Box>
  );
};

export default Layout;